const maths = {
    title: 'Mathematical',
    characters: [
        {character: '<', title: 'Less-than sign'},
        {character: '>', title: 'Greater-than sign'},
        {character: '≤', title: 'Less-than or equal to'},
        {character: '≥', title: 'Greater-than or equal to'},
        {character: '–', title: 'En dash'},
        {character: '—', title: 'Em dash'},
        {character: '¯', title: 'Macron'},
        {character: '‾', title: 'Overline'},
        {character: '°', title: 'Degree sign'},
        {character: '−', title: 'Minus sign'},
        {character: '±', title: 'Plus-minus sign'},
        {character: '÷', title: 'Division sign'},
        {character: '⁄', title: 'Fraction slash'},
        {character: '×', title: 'Multiplication sign'},
        {character: 'ƒ', title: 'Latin small letter f with hook'},
        {character: '∫', title: 'Integral'},
        {character: '∑', title: 'N-ary summation'},
        {character: '∞', title: 'Infinity'},
        {character: '√', title: 'Square root'},
        {character: '∼', title: 'Tilde operator'},
        {character: '≅', title: 'Approximately equal to'},
        {character: '≈', title: 'Almost equal to'},
        {character: '≠', title: 'Not equal to'},
        {character: '≡', title: 'Identical to'},
        {character: '∈', title: 'Element of'},
        {character: '∉', title: 'Not an element of'},
        {character: '∋', title: 'Contains as member'},
        {character: '∏', title: 'N-ary product'},
        {character: '∧', title: 'Logical and'},
        {character: '∨', title: 'Logical or'},
        {character: '¬', title: 'Not sign'},
        {character: '∩', title: 'Intersection'},
        {character: '∪', title: 'Union'},
        {character: '∂', title: 'Partial differential'},
        {character: '∀', title: 'For all'},
        {character: '∃', title: 'There exists'},
        {character: '∅', title: 'Empty set'},
        {character: '∇', title: 'Nabla'},
        {character: '∗', title: 'Asterisk operator'},
        {character: '∝', title: 'Proportional to'},
        {character: '∠', title: 'Angle'},
        {character: '¼', title: 'Vulgar fraction one quarter'},
        {character: '½', title: 'Vulgar fraction one half'},
        {character: '¾', title: 'Vulgar fraction three quarters'}
    ]
}

export default maths